<template>
  <div>
    <modal :show.sync="localDisplay" :closeIcon="false">
      <modal-header :style-name="{ backgroundColor: '#0081F91A' }" class="mb-3">
        <div slot="icon" class="d-inline-flex">
          <IconWrapper
            :icon="{
              iconType: 'fa',
              value: 'clone',
              color: '#0081F9',
            }"
            :size="32"
          />
        </div>
        <div>
          <p class="mt-3 mb-0 font-weight-bold">
            {{ $t('knowledge.modals.clone-kb.header-title') }}
          </p>
        </div>
        <div slot="footer">
          <div class="d-flex align-items-center header-footer">
            <div class="icon-background">
              <font-awesome-icon
                v-if="sourceType === 'case'"
                class="icon"
                :icon="['fad', 'folder-open']"
              />
              <font-awesome-icon
                v-else-if="sourceType === 'contents'"
                class="icon"
                :icon="['fal', 'file-alt']"
              />
              <img
                v-else-if="sourceType === 'Article'"
                src="~assets/article_icon.svg"
                class="icon"
              />
              <img
                v-else-if="sourceType === 'Diagnostic'"
                src="~assets/diag_icon.svg"
                class="icon"
              />
            </div>
            <div class="pl-2 text-left">
              <div class="label">{{ sourceLabel }}</div>
              <div class="sub-label">
                {{ subLabel }}
              </div>
            </div>
          </div>
        </div>
      </modal-header>

      <div class="clone-zone">
        <div v-if="sourceType === 'case'" class="mb-3">
          <div class="d-flex align-items-center justify-content-between">
            <div class="label">
              {{ $t('knowledge.modals.clone-kb.rename') }}
            </div>
            <el-switch v-model="switchCaseName"></el-switch>
          </div>
          <base-input
            :ref="'input'"
            v-show="switchCaseName"
            class="mt-2 case-input"
            :placeholder="sourceLabel"
            v-model="newCaseName"
          ></base-input>
        </div>
        <div class="mb-2 label">
          {{ $t('knowledge.modals.clone-kb.choose-kb') }}
        </div>
        <base-button-cascader
          :icon="optionIcon"
          :name="targetLabel"
          :placeholder="storeFocusKnowledge.label"
          :showCascader="showCascader"
          @show="handleShow($event)"
        >
          <CascaderWrapper
            :source-type="sourceType"
            :source-id="sourceId"
            @clone-to-target="handleClone($event)"
            @close="showCascader = false"
          />
        </base-button-cascader>
      </div>
      <div class="mt-4 d-flex justify-content-end">
        <ModalActions
          :primaryEnabled="target ? true : false"
          @primary="cloneToTarget"
          v-loading="isLoading"
        />
      </div>
    </modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import Modal from '@/components/Modal';
import ModalHeader from '@/components/Modals/ModalHeader';
import IconWrapper from '@/components/IconWrapper';
import ModalActions from '@/components/Modals/ModalActions';
import CascaderWrapper from '@/components/CascaderWrapper';
import BaseButtonCascader from '@/components/BaseButtonCascader';

export default {
  name: 'clone-knowledge-base-modal',
  components: {
    Modal,
    ModalHeader,
    IconWrapper,
    ModalActions,
    CascaderWrapper,
    BaseButtonCascader,
  },
  props: {
    display: Boolean,
    sourceType: {
      type: String,
      default: 'case', // 'case' || 'contents'
    },
    sourceLabel: String,
    sourceId: String,
  },
  data() {
    return {
      localDisplay: this.display,
      showCascader: false,
      target: null,
      targetLabel: null,
      switchCaseName: false,
      newCaseName: '',
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters('knowledgeModule', {
      storeFocusKnowledge: 'focusKnowledge',
    }),
    optionIcon() {
      return this.target && this.target.caseId
        ? ['fas', 'folder']
        : ['fad', 'books'];
    },
    subLabel() {
      if (this.sourceType === 'case') {
        return this.$t('knowledge.modals.clone-kb.header-sub-label');
      } else if (this.sourceType === 'contents') {
        return '';
      } else {
        return this.sourceType.toUpperCase();
      }
    },
  },
  methods: {
    cloneToTarget() {
      this.$emit('clone-to-target', this.target);
      this.isLoading = true;
    },
    handleClone(target) {
      this.targetLabel = target.label;
      this.target = {
        caseName: this.newCaseName ? this.newCaseName : this.sourceLabel,
        targetCaseId: target.caseId,
        targetKnowledge: target.knowledge,
        targetKnowledgeId: target.knowledgeId,
      };
      this.showCascader = false;
    },
    handleShow(show) {
      this.showCascader = show;
    },
  },
  watch: {
    localDisplay() {
      if (!this.localDisplay) this.$emit('close');
    },
    switchCaseName() {
      this.newCaseName = '';
      this.$nextTick(() => this.$refs.input.focus());
    },
  },
};
</script>
<style lang="scss" scoped>
.header-footer {
  padding: 8px;
  background: white;
  border-radius: 2px;

  .icon {
    width: 24px;
    height: 24px;
    color: $grey-5-mayday;
  }

  .icon-background {
    padding: 16px 16px;
    background-color: $grey-1-mayday;
    border: 0.5px solid $grey-4-mayday;
    border-radius: 2px;
  }

  .label {
    font-weight: bold;
  }

  .sub-label {
    font-size: 8px;
    font-weight: bold;
    color: $grey-5-mayday;
  }
}
.clone-zone {
  padding: 18px;
  border: 1px solid $blue-mayday;
  border-radius: 2px;

  .label {
    font-weight: bold;
  }
}
.case-input {
  :deep() .form-control {
    font-size: 1rem;
    font-weight: bold;
    color: $grey-8-mayday;
  }
  :deep() .form-control::placeholder {
    font-weight: bold;
    color: $grey-5-mayday;
  }
}
</style>
